import { render, staticRenderFns } from "./FormulaEditor.vue?vue&type=template&id=2540d0f3&scoped=true"
import script from "./FormulaEditor.vue?vue&type=script&lang=js"
export * from "./FormulaEditor.vue?vue&type=script&lang=js"
import style0 from "./FormulaEditor.vue?vue&type=style&index=0&id=2540d0f3&prod&scoped=true&lang=css"
import style1 from "./FormulaEditor.vue?vue&type=style&index=1&id=2540d0f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540d0f3",
  null
  
)

export default component.exports